import { ArrowLeft } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center">
      <h1 className="mb-8 md:mb-10 !text-[80px] md:!text-[120px]">404</h1>
      <p className="b2 text-grey-08 mb-1">Ooops! Page Not Found</p>

      <Link to={"/"} className="flex items-center gap-1 text-blue-06">
        <ArrowLeft size={16} />
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
